export const updateModelAvailability= `mutation updateModelAvailability($input: UpdateCopyModelAvailabilityRequest!) {
  updateModelAvailability(input: $input) {
      pkId
      message
      status
      startDate
      endDate
      createDate
      lastModifiedDate
  }
}`;

  export const updateTofModelAvailability= `mutation updateTofModelAvailability($input: ModelAvailabilityOthRegRequest!) {
    updateTofModelAvailability(input: $input) {
      pkId
      message
      status
      startDate
      endDate
      createDate
      lastModifiedDate
    }
  }`;